import React, { useEffect, useState } from 'react'
import { Button } from './Button'
import './signOut.css'
import { supabase } from '../utils/supabase_config';

export const SignOut = () => {
    const [isSignedIn, setIsSignedIn] = useState(false);

    useEffect(() => {
        supabase.auth.getSession().then(({ data: { session } }) => {
            setIsSignedIn(!!session?.user);
        });

        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            setIsSignedIn(!!session?.user);
        });

        return () => subscription.unsubscribe();
    }, []);

    const handleSignOut = async () => {
        try {
            await supabase.auth.signOut();
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    return isSignedIn ? (
        <div className="signOutDiv">
            <div className="buttonDiv">
                <Button onClick={handleSignOut}
                    type="button"
                    buttonStyle="btn--danger--solid"
                    buttonSize="btn--medium"
                >
                    Sign Out
                </Button>
            </div>
        </div>
    ) : null;
}
